/**
*  料金シミュレーター
*
*  通所リハビリテーション
*
*  @since 2019.9.24
*  @use jQuery
*/




/**
*  Variables
*
*  自己負担となる利用金額
*/

const array_daycare = {
  /* 介護度に応じたサービス料 */
  kaigo:
  [
    // 介護度 1 : [ 1割, 2割, 3割 ]
    {
      oneToTwo : [ 536, 1022, 1508 ],
      twoToThree: [ 570, 1090, 1610 ],
      threeToFour: [ 1558, 2196, 834 ],
      fourToFive: [ 1632, 2344, 3056 ],
      fiveToSix: [ 1701, 2482, 3264 ],
      sixToSeven: [ 1810, 2701, 3591 ]
    },
    // 介護度 2 : [ 1割, 2割, 3割 ]
    {
      oneToTwo : [ 570, 1090, 1610 ],
      twoToThree: [ 1494, 2068, 2642 ],
      threeToFour: [ 1643, 2366, 3089 ],
      fourToFive: [ 1726, 2533, 3340 ],
      fiveToSix: [ 1822, 2725, 3628 ],
      sixToSeven: [ 1953, 2987, 4021 ]
    },
    // 介護度 3 : [ 1割, 2割, 3割 ]
    {
      oneToTwo : [ 602, 1154, 1706 ],
      twoToThree: [ 1618, 2317, 3016 ],
      threeToFour: [ 1726, 2533, 3340 ],
      fourToFive: [ 1820, 2721, 3621 ],
      fiveToSix: [ 1943, 2967, 3991 ],
      sixToSeven: [ 2096, 3272, 4448 ]
    },
    // 介護度 4 : [ 1割, 2割, 3割 ]
    {
      oneToTwo : [ 634, 1218, 1802 ],
      twoToThree: [ 1681, 2443, 3204 ],
      threeToFour: [ 1833, 2747, 3661 ],
      fourToFive: [ 1941, 2963, 3985 ],
      fiveToSix: [ 2088, 3256, 4425 ],
      sixToSeven: [ 2260, 3600, 4940 ]
    },
    // 介護度 5 : [ 1割, 2割, 3割 ]
    {
      oneToTwo : [ 668, 1286, 1905 ],
      twoToThree: [ 1544, 2169 , 2794 ],
      threeToFour: [ 1940, 2961, 3981 ],
      fourToFive: [ 2064, 3208, 4352 ],
      fiveToSix: [ 2228, 3536, 4844 ],
      sixToSeven: [ 2425, 3931, 5436 ]
    },
    // 要支援 1 : [ 1割, 2割, 3割 ]
    {
      oneToTwo : [ 0, 0, 0 ],
      twoToThree: [ 0, 0, 0 ],
      threeToFour: [ 0, 0, 0 ],
      fourToFive: [ 0, 0, 0 ],
      fiveToSix: [ 0, 0, 0 ],
      sixToSeven: [ 0, 0, 0 ]
    },
    // 要支援 2 : [ 1割, 2割, 3割 ]
    {
      oneToTwo : [ 0, 0, 0 ],
      twoToThree: [ 0, 0, 0 ],
      threeToFour: [ 0, 0, 0 ],
      fourToFive: [ 0, 0, 0 ],
      fiveToSix: [ 0, 0, 0 ],
      sixToSeven: [ 0, 0, 0 ]
    }
  ],
  // １週の利用日数 [ 週1日, 週2日, 週3日 ]
  week: [ 4, 8, 12 ]
}

// '1週間あたりの利用回数' の OPTION 項目の配列
const weekOptionArray = [
  '選択してください',
  '週1日',
  '週2日',
  '週3日'
];

/**
*  function
*  動作
*/

// 通所リハビリテーション
$( calcBtn.rehaDaycare ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.rehaDaycare ).serializeArray();
  const selectVal = selectCheck( currentForm.rehaDaycare, formData );
  let daysExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 1日の利用時間に応じて居住費を設定
    switch( parseInt( selectVal.days, 10 ) )
    {

      // 1～2時間
      case 1:
        daysExpense = array_daycare.kaigo[ selectVal.kaigo ].oneToTwo[ selectVal.futan ];
      break;

      // 2～3時間
      case 2:
        daysExpense = array_daycare.kaigo[ selectVal.kaigo ].twoToThree[ selectVal.futan ];
      break;

      // 3～4時間
      case 3:
        daysExpense = array_daycare.kaigo[ selectVal.kaigo ].threeToFour[ selectVal.futan ];
      break;

      // 4～5時間
      case 4:
        daysExpense = array_daycare.kaigo[ selectVal.kaigo ].fourToFive[ selectVal.futan ];
      break;

      // 5～6時間
      case 5:
        daysExpense = array_daycare.kaigo[ selectVal.kaigo ].fiveToSix[ selectVal.futan ];
      break;

      // 6～7時間
      case 6:
        daysExpense = array_daycare.kaigo[ selectVal.kaigo ].sixToSeven[ selectVal.futan ];
      break;

      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する
    const result = parseInt( daysExpense, 10) * parseInt( selectVal.weeks, 10);
    $( resultElm.rehaDaycare ).html( numberWithComma.format( result ) );
  } // end of 計算処理開始
return;
});

// '介護度' を変更したとき '1週間あたりの利用回数' の内容を書き換える
$( currentForm.rehaDaycare + ' [name="kaigo"]' ).on('change', function(){
  const kaigoValue = this.selectedIndex;
  const weekOption = this.form.weeks;

  if ( kaigoValue === 6 ) {
    weekOption.textContent = null;
    weekOption.options[0] = new Option( weekOptionArray[0], '' );
    weekOption.options[1] = new Option( weekOptionArray[1], array_daycare.week[0] );
  } else if ( kaigoValue === 7 ) {
    weekOption.textContent = null;
    weekOption.options[0] = new Option( weekOptionArray[0], '' );
    weekOption.options[1] = new Option( weekOptionArray[2], array_daycare.week[1] );
  } else {
    weekOption.textContent = null;
    weekOption.options[0] = new Option( weekOptionArray[0], '' );
    weekOption.options[1] = new Option( weekOptionArray[1], array_daycare.week[0] );
    weekOption.options[2] = new Option( weekOptionArray[2], array_daycare.week[1] );
    weekOption.options[3] = new Option( weekOptionArray[3], array_daycare.week[2] );
  }
});
